import React from 'react';
import Navbar from '../../../shared/components/Navbar';
import Footer from '../../../shared/components/Footer';
import BackgroundImage from '../../../shared/components/BackgroundImage';
import Card from '../../../shared/components/Card';

interface LegalPageProps {
  title: string;
  subtitle: string;
  lastUpdate: string;
  lastUpdateDate: string;
  children: React.ReactNode;
}

const LegalPage: React.FC<LegalPageProps> = ({ title, subtitle, lastUpdate, lastUpdateDate, children }) => (
  <div className="min-h-screen relative">
    <BackgroundImage />
    <Navbar />
    <div className="relative z-10">
      <section className="pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 text-gradient">
            {title}
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {subtitle}
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              {children}

              <div className="mt-12 p-5 bg-gray-800/60 rounded-xl border-l-4 border-primary-500">
                <p className="text-base font-medium text-gray-300">
                  <span className="text-white font-semibold">{lastUpdate} :</span>{' '}
                  {lastUpdateDate}
                </p>
              </div>
            </div>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  </div>
);

export default LegalPage;
